// test39
(39 && 0);
